fbm.add("util/alert", ["util/pause"], function (upause) {

    const {
        pause
    } = {
        ...upause
    };

    async function alert(text) {
        let terminal = document.querySelector(".terminal");
        let access = document.createElement("div");
        access.setAttribute("class", "access-granted");
        access.innerHTML = text;
        terminal.appendChild(access);
        await pause(2);
        access.remove();
    }

    async function err(text) {
        let terminal = document.querySelector(".terminal");
        let access = document.createElement("div");
        access.setAttribute("class", "access-denied");
        access.innerHTML = text;
        terminal.appendChild(access);
        await pause(2);
        access.remove();
    }

    return {err, alert}
});
